module.exports = __webpack_public_path__ + "static/media/analytics-line.a504f1a9.svg";